import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MainLayoutComponent } from './main.component';
import { AuthLayoutComponent } from './auth.component';
import { LayoutRoutingModule } from './layout-routing.module';
import { SearchFormComponent } from '../_layout/search-form.component';

/*Materials*/
import {MatIconModule, MatCardModule} from '@angular/material';

@NgModule({
  imports: [
    MatIconModule, 
    MatCardModule,
    FormsModule,
    CommonModule,
    LayoutRoutingModule,
  ],
  exports: [],
  declarations: [
    MainLayoutComponent,
    AuthLayoutComponent,
    SearchFormComponent
  ]
})
export class LayoutModule { }
